const commonHelpers = {
  data: function () {
    return {}
  },
  methods: {
    // FE Actions
    async onDestroy (item) {
      const result = await this.$dialog.confirm({
        title: this.$t('delete-question'),
        text: this.$t('deleted-item-can-be-restored-notice')
      })

      if (result)
        this.onDestroyConfirm(item)
    },
    // Actions
    async onDestroyConfirm (item) {
      await this.$store.dispatch('destroyItem', { model: this.model, id: item.id })
      this.reRoute({ afterDestroy: true })
      // Snackbar after succesful archive (must come after re-routing)
      this.$store.commit('setFlat', { param: 'archivedSnackbar', val: true })
    },
    // Routings
    reRoute (attrs) {
      // Implemented where inherited by mixin
      console.warn('[common-helpers][reRotue]')
    }
  }
}

export default commonHelpers
